import React, { useEffect, useContext } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
// import io from "socket.io-client";
import { SocketContext } from '../../contexts/socketContext';
import { fetchDetectorEvents } from '../../actions';
import { Content } from '../layout';

const DetectorList = () => {
  const dispatch = useDispatch();
  const socket = useContext(SocketContext);

  const { detectorEvents } = useSelector((state) => state.detectorEvent);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      dispatch(fetchDetectorEvents());
    }
  }, [dispatch, user]);

  useEffect(() => {
    socket.on('detector_event_counter', ({ chipID }) => {
      dispatch(fetchDetectorEvents());

      let chipRows = document.querySelectorAll('tbody tr');
      //chipRows.forEach((value, index) => console.log("value", value));
      let row = Array.from(chipRows).find(
        (row) => row.firstChild.innerText === String(chipID)
      );
      // console.log("row", row);
      let count = 0;
      let interval = setInterval(() => {
        count++;
        if (count % 2 === 0) {
          row.style.backgroundColor = 'black';
          row.style.color = 'white';
        } else {
          row.style.backgroundColor = '';
          row.style.color = '';
        }
        if (count === 5) {
          clearInterval(interval);
        }
        // console.log("interval count", count);
      }, 1000);
    });
  }, [dispatch, socket]);

  const renderDetectorEvents = () => {
    if (!detectorEvents) {
      return;
    }
    return detectorEvents.map((detector) => (
      <TableRow
        key={detector.chipID}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell>{detector.chipID}</TableCell>
        <TableCell>{detector.name}</TableCell>
        <TableCell>{detector.EventCount}</TableCell>
      </TableRow>
    ));
  };
  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            감지기 모니터
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="worker-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>칩 ID</TableCell>
                  <TableCell>감지기명</TableCell>
                  <TableCell>감지 횟수</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderDetectorEvents()}</TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Content>
  );
};

export default DetectorList;
